/**
 * Scheduling Options Settings Page
 * Hosts the Group Appointments card (enable group booking + online group booking config).
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { GroupAppointmentsCard } from './calendar-appointments/components/group-appointments-card'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/settings/calendar-appointments/scheduling-options')({
  component: SchedulingOptionsPage,
})

function SchedulingOptionsPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/calendar-appointments/scheduling-options',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Scheduling Options', 'Calendar & Appointments')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="scheduling-options">
        <SettingsPageHeader
          title="Scheduling Options"
          description="Configure group appointments and how clients can book them online."
        />

        <div className="space-y-6 max-w-2xl">
          <GroupAppointmentsCard />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
